import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import { ROUTES } from '../data/site';

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    const route = ROUTES.find((r) => r.path === pathname);
    document.title = route ? route.title : 'Halaman Tidak Ditemukan — Ayam Goreng Widuran';
  }, [pathname]);
  return (
    <>
      <a
        href="#konten-utama"
        data-testid="skip-to-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:top-2 focus:left-2 focus:bg-[#2B1B12] focus:text-[#FDFBF7] focus:px-4 focus:py-2 focus:rounded-md"
      >
        Langsung ke konten
      </a>
      <SiteHeader />
      <main id="konten-utama">
        <Outlet />
      </main>
      <SiteFooter />
    </>
  );
}
